import { initializeApp } from "firebase/app";
import { getFirestore, collection, addDoc } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyD-IXWb-9OeJYOnzSs3Izrx41DtAfzNopA",
  authDomain: "cyberinn-129f4.firebaseapp.com",
  projectId: "cyberinn-129f4",
  storageBucket: "cyberinn-129f4.firebasestorage.app",
  messagingSenderId: "758871503264",
  appId: "1:758871503264:web:ff38f552e76c1589b3f4c5",
  measurementId: "G-QXF3H2X6Q6"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

// Enrollment collection reference
const enrollmentsRef = collection(db, "enrollments");

export { db, enrollmentsRef, addDoc, collection };